import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const StyledSignatureWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  .signature-container {
    @media ${DEVICES.sm} {
      width: 100%;
    }
  }
`;

export const SignatureContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .signature-field {
    background: white;
    border: 1px solid #a7aeba;
    height: 102px;
    max-width: 100%;
    width: 290px;
    margin-bottom: 0;
    margin-top: 0;
    border-radius: 4px;
  }
  .ant-btn {
    cursor: pointer;
    max-width: 100px;
    padding: 4px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media ${DEVICES.sm} {
    .signature-field {
      width: 296px;
    }
  }
`;
